<template>
  <v-container>
    <module-bar title="ADMINISTRAR INCONVENIENTES" icon="mdi-account-question" />

    <v-row class="mt-5" v-if="loadingSearch">
      <v-col cols="12" class="d-flex justify-center">
        <v-progress-circular indeterminate color="primary" width="2" size="60" />
      </v-col>
    </v-row>

    <v-card outlined class="mt-10" v-if="items.length > 0">
      <v-card-text>
        <div>
          ({{ items.length }})
          {{ items.length == 1 ? " item encontrado" : " items encontrados" }}
        </div>
        <v-list>
          <v-list-item-group color="primary">
            <template v-for="(item, key) in items">
              <v-list-item :key="key" v-if="items" @click="openDialogItem(key)">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.name.toUpperCase() }}
                    <span class="ml-2">
                      <v-icon :color="item.enabled ? `green` : `red`">mdi-circle</v-icon>
                    </span>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ item.type_name }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="`key${key}`" v-if="key != items.length - 1" />
            </template>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogItem" persistent width="800">
      <v-card>
        <v-card-text>
          <item-form schema="edit" :item="item" :click="click" title="EDITAR ITEM" @closeDialogItem="closeDialogItem" @deleteItem ="deleteItem" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ItemForm from "../../components/Forms/ItemForm.vue";
import ModuleBar from "../../components/General/ModuleBar.vue";

export default {
  components: { ModuleBar, ItemForm },

  mounted() {
    this.search();
  },

  data() {
    return {
      dialogItem: false,
      click: 0,
      items: [],
      item: {},
      params: "",
      loadingSearch: false,
    };
  },

  methods: {
    search() {
      this.loadingSearch = true;
      this.items = [];
      setTimeout(() => {
        let payload = {
          params: this.params,
        };

        this.$store
          .dispatch("findItemsParamsAction", payload)
          .then((res) => {
            this.items = res;
            this.loadingSearch = false;
          })
          .catch(() => {
            this.loadingSearch = false;
          });
      }, 500);
    },

    openDialogItem(key) {
      this.click++;
      this.item = this.items[key];
      this.dialogItem = true;
    },

    closeDialogItem(data) {
      this.dialogItem = false;

      if (data) {
        let index = this.items.findIndex((v) => v.id == data.id);
        data.type_name = data.type.name;
        data.enabled = parseInt(data.enabled);
        this.items.splice(index, 1, data);
      }
    },

    deleteItem(itemId){
      let index = this.items.findIndex((v) => v.id == itemId);
      this.items.splice(index, 1);
      this.dialogItem = false;
    }
  },
};
</script>

<style></style>
